<div
  class="munily-area-picture-uploader"
  [ngClass]="containerClasses"
  [attr.role]="!isFilled ? 'button' : null"
  [attr.tabindex]="!isFilled && !disabled ? 0 : null"
  [attr.aria-disabled]="disabled || null"
  (click)="onContainerClick()"
  (keydown.enter)="onContainerClick()"
  (keydown.space)="onContainerClick()"
>
  <ng-container *ngIf="isFilled; else emptyState">
    <img
      class="munily-area-picture-uploader__img"
      [src]="safeImageSrc"
      [alt]="alt"
    />
    <div class="munily-area-picture-uploader__overlay" aria-hidden="true"></div>
    <mat-icon
      *ngIf="selected"
      class="munily-area-picture-uploader__check material-symbols-rounded"
      aria-hidden="true"
    >
      check_circle
    </mat-icon>

    <div class="munily-area-picture-uploader__menu">
      <common-icon-button
        variant="plain"
        icon="more_vert"
        iconSet="material-icons-outlined"
        ariaLabel="{{ 'commonComponents.areaPictureUploader.menu.ariaLabel' | translate }}"
        [stopClickPropagation]="true"
        [menuTriggerFor]="menu"
      ></common-icon-button>
    </div>

    <mat-menu #menu="matMenu">
      <button *ngIf="showReplaceOption" mat-menu-item type="button" (click)="onMenuAction('replace')">
        {{ 'commonComponents.areaPictureUploader.menu.replace' | translate }}
      </button>
      <button *ngIf="showSetPrimaryOption && !selected" mat-menu-item type="button" (click)="onMenuAction('setPrimary')">
        {{ 'commonComponents.areaPictureUploader.menu.setPrimary' | translate }}
      </button>
      <button *ngIf="showDeleteOption" mat-menu-item type="button" (click)="onMenuAction('delete')">
        {{ 'commonComponents.areaPictureUploader.menu.delete' | translate }}
      </button>
    </mat-menu>
  </ng-container>

  <ng-template #emptyState>
    <mat-icon class="munily-area-picture-uploader__icon material-symbols-rounded" aria-hidden="true">image</mat-icon>
  </ng-template>
</div>
